// extracted by mini-css-extract-plugin
export var button = "_6c-4";
export var hasDarkBackground = "_6c-7";
export var hasLightBackground = "_6c-6";
export var iconWrapper = "_6c-0";
export var large = "_6c-2";
export var medium = "_6c-1";
export var small = "_6c-5";
export var xsmall = "_6c-3";